import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export interface ConditionalFailmarkProps {
  show: boolean;
}

export function ConditionalFailmark({ show }: ConditionalFailmarkProps) {
  return (
    <div>
      {show && <FontAwesomeIcon icon={faTimes} className="text-red-400" />}
    </div>
  );
}
